import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Input from "@material-ui/core/InputBase";
import Label from "@material-ui/core/FormLabel";
import { Typography } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import AddIcon from "@material-ui/icons/Add";
import styled from "styled-components";
import { useReducer, useState } from "react";
import { render } from "@testing-library/react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import { subject } from "../../service";
import "./Consultation.css";
import { ADImage } from "../../style/Header";
import Header from "../Header/Header";
import PanazCreative from "../NewCreatives/PanazCreative/PanazCreative";
import PrimeraCreative from "../NewCreatives/PrimeraCreative/PrimeraCreative";
import MedizenCreative from "../NewCreatives/MedizenCreative/MedizenCreative";
import Mycontext from "../../store/Mycontext";
import myImg from "../../../src/assets/Ads/vertical.jpeg";
import MedizenVerticalAd from "../../assets/Ads/MedizenV.jpg";
import PrimeraVerticalAd from "../../assets/Ads/PrimeraV.jpg";
import PanazVerticalAd from "../../assets/Ads/PanazV.jpg";

const Container = styled.div`
  max-width: 100%;
  border-radius: 7px;
  border: 1px solid #c5c5c5;
  padding-bottom: 40px;
  background-color: white;
`;
const useStyles = (theme) => ({
  root: {},
  New: {
    color: "#4678ED",
    fontWeight: 600,
    padding: 20,
    paddingTop: "12px",
    display: "flex",
    fontSize: "15.5px",
    justifyContent: "flex-start",
    fontFamily:
      "Montserrat SemiBold, 'Open Sans', Helvetica, Arial, sans-serif",
  },
  label: {
    fontSize: "12px",
    color: "#58595B",
    display: "flex",
    fontWeight: 500,
    justifyContent: "flex-start",
    alignItems: "flex-start",
    fontFamily: "Montserrat Medium, 'Open Sans', Helvetica, Arial, sans-serif",
    padding: 20,
  },
  input1: {
    marginTop: 15,
    height: 25,
    width: "100%",
    borderRadius: 3,
    justifyItems: "flex-start",
    fontSize: "11px",
    fontWeight: 600,
    color: "#606060",
    fontFamily:
      "Montserrat SemiBold, 'Open Sans', Helvetica, Arial, sans-serif",
    paddingLeft: "20px",
    border: "1px solid #e6e6e6",
    "& input::placeholder": {
      fontSize: 10,
      display: "flex",
      color: "black",
      paddingLeft: 15,
      fontWeight: 500,
    },
  },
  button: {
    marginTop: 10,
    fontSize: 12,
    textTransform: "none",
    height: 30,
    width: "100%",
    backgroundColor: "#E6E6E6",
    color: "#58595B",
    fontWeight: 500,
    fontFamily: "Montserrat Medium, 'Open Sans', Helvetica, Arial, sans-serif",
    "&:hover": {
      backgroundImage:
        "linear-gradient(315deg, #4487d1 0%, #009ffd 74%) !important",
      color: "white !important",
    },
  },
  select: {
    marginTop: 15,
    marginLeft: 3,
    height: 25,
    minWidth: "240px",
    maxWidth: "240px",
    borderRadius: 3,
    justifyItems: "flex-start",
    border: "none",
    backgroundColor: "none !important",
    fontSize: "11px",
    fontWeight: 600,
    color: "#606060",
    fontFamily:
      "Montserrat SemiBold, 'Open Sans', Helvetica, Arial, sans-serif",
    "@media (maxWidth:1456px)": {
      minWidth: "190px",
      maxWidth: "190px",
    },

    // "&:focus"{

    // }
  },
  Textarea: {
    minHeight: 70,
    width: "100%",
    marginLeft: 5,
    paddingLeft: "10px",
    border: " 1px solid #e6e6e6",
    borderRadius: 5,
    fontSize: "11px",
    fontWeight: 600,
    color: "#606060",
    fontFamily:
      "Montserrat SemiBold, 'Open Sans', Helvetica, Arial, sans-serif",
  },
  Textarea1: {
    fontSize: "11px",
    fontWeight: 600,
    paddingLeft: "10px",
    color: "#606060",
    fontFamily:
      "Montserrat SemiBold, 'Open Sans', Helvetica, Arial, sans-serif",
    width: "100%",
    minHeight: 20,
    marginLeft: 5,
    marginTop: 18,
    border: " 1px solid #e6e6e6",
    borderRadius: 5,
  },
  input2: {
    height: 25,
    marginLeft: 5,
    width: "100%",
    paddingLeft: "10px",
    borderRadius: 3,
    display: "flex",
    fontSize: "11px",
    fontWeight: 600,
    color: "#606060",
    fontFamily:
      "Montserrat SemiBold, 'Open Sans', Helvetica, Arial, sans-serif",
    justifyItems: "flex-start",
    border: "1px solid #e6e6e6",
    "& input::placeholder": {
      fontSize: 10,
      display: "flex",
      fontWeight: "bold",
      color: "black",
      paddingLeft: 12,
      fontWeight: 500,
    },
  },
});

const formReducer = (state, event) => {
  return {
    ...state,
    [event.name]: event.value,
  };
};

const defaultBanner = (
  <ADImage
    src={"Ads/Horizontal1.jpeg"}
    alt="Advertise"
    width="668px"
    height="90px"
  />
);
class NewConsultant extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.calculateNewState = this.calculateNewState.bind(this);
    this.restoreState = this.restoreState.bind(this);
    this.sendMessage = this.sendMessage.bind(this);
    this.handleClick = this.handleClick.bind(this);

    this.state = {
      days: "",
      notes: "",
      history: "",
      examination: "",
      smoking: false,
      imagesel: "Ads/Horizontal1.jpeg",
      cMap: new Map([
        [
          0,
          {
            days: "",
            notes: "",
            history: "",
            examination: "",
            smoking: false,
            imagesel: "Ads/Horizontal1.jpeg",
          },
        ],
        [
          1,
          {
            days: "8 Weeks",
            notes: "TB ruled out",
            history: "Asthma",
            examination:
              "Heavy breathing and breathlessness observed with 2MWT",
            smoking: true,
            imagesel: "Ads/Horizontal2.jpeg",
          },
        ],
        [
          2,
          {
            days: "3 Days",
            notes: "",
            history: "Patient is T2DM",
            examination: "SPO2 - 94 , Temperature - 103.2F",
            smoking: false,
            imagesel: "Ads/Horizontal3.jpeg",
          },
        ],
        [
          3,
          {
            days: "4 Weeks",
            notes: "",
            history:
              "Patient is an identified T2DM with 11 years disease history. Currently on OHAs",
            examination:
              "A Pin Pirck Test confirmed reduced sensitivity to pain in legs",
            smoking: false,
            imagesel: "Ads/Horizontal4.jpeg",
          },
        ],
        [
          3,
          {
            days: "4 Weeks",
            notes: "",
            history:
              "Patient is an identified T2DM with 11 years disease history. Currently on OHAs",
            examination:
              "A Pin Pirck Test confirmed reduced sensitivity to pain in legs",
            smoking: false,
            imagesel: "Ads/Horizontal4.jpeg",
          },
        ],
      ]),
      oldkey: 0,
      // keyToBanner: {
      //   0: defaultBanner,
      //   1: defaultBanner,
      //   2: defaultBanner,
      //   3: defaultBanner,
      //   4: <PanazCreative />,
      // },
      loginAds: {
        1: MedizenVerticalAd,
        2: PrimeraVerticalAd,
        3: PanazVerticalAd,
      },

    };

    this.restoreState();
  }

  sendMessage = () => {
    let imagesel = {
      headerImg: this.state.imagesel,
      leftImg: "",
      bottomImg: "",
    };

    subject.next(JSON.stringify(imagesel));
  };
  restoreState() {
    let key = window.sessionStorage.getItem("keyselected");
    if (key) {
      this.state.oldkey = parseInt(key);
      this.calculateNewState(this.state.oldkey);
    }
  }

  calculateNewState = (key) => {
    let dataset = this.state.cMap.get(key);
    if (dataset) {
      this.state.days = dataset.days;
      this.state.notes = dataset.notes;
      this.state.history = dataset.history;
      this.state.examination = dataset.examination;
      this.state.smoking = dataset.smoking;
      this.state.imagesel = dataset.imagesel;
      this.forceUpdate();
    }
  };
  handleChange = (event, randValue) => {
    this.calculateNewState(event.target.value);

    window.sessionStorage.setItem("keyselected", event.target.value);

    this.sendMessage();
  };
  handleClick = (e, value) => {
    console.log(">>>value", value);
    const banner = this.state.loginAds[value] || this.props.selectedBanner;
    this.props.setSelectedBanner(banner);
    sessionStorage.setItem("rValue", value);
  };
  static contextType = Mycontext;

  render() {
    const { classes } = this.props;
    const { randValue } = this.context;
    return (
      <div className={classes.root}>
        <form>
          <Container>
            <Grid item md={12}>
              <Typography className={classes.New}>New Consultation</Typography>
            </Grid>
            <Grid container spacing={2}>
              <Grid item md={3}>
                <Label className={classes.label}>Chief Complaint</Label>
              </Grid>
              <Grid item md={3}>
                <div>
                  <FormControl variant="outlined">
                    <Select
                      className={classes.select}
                      defaultValue={this.state.oldkey}
                      name="complaint"
                      onChange={(e) => this.handleChange(e, randValue)}
                    >
                      <MenuItem
                        style={{ fontSize: "13px", fontWeight: 500 }}
                        value={0}
                      >
                        None
                      </MenuItem>
                      <MenuItem
                        style={{ fontSize: "13px", fontWeight: 500 }}
                        value={1}
                        onClick={(e) => this.handleClick(e, "1")}
                      >
                        Autosomal Dominant Polycystic Kidney Disease
                      </MenuItem>
                      <MenuItem
                        style={{ fontSize: "13px", fontWeight: 500 }}
                        value={2}
                        onClick={(e) => this.handleClick(e, "2")}
                      >
                        Type II Diabetes
                      </MenuItem>
                      <MenuItem
                        style={{ fontSize: "13px", fontWeight: 500 }}
                        value={3}
                        onClick={(e) => this.handleClick(e, "3")}
                      >
                        Bone Marrow Cancer - Myleofibrosis
                      </MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </Grid>
              <Grid item md={1}>
                <div>
                  <Button className={classes.button}>Accept</Button>
                </div>
              </Grid>
              <Grid item md={1}>
                <Label
                  className={classes.label}
                  style={{
                    fontSize: 13,
                    paddingLeft: "0px",
                    paddingRight: "0px",
                  }}
                >
                  for
                </Label>
              </Grid>
              <Grid item md={3}>
                <Input
                  className={classes.input1}
                  name="days"
                  value={this.state.days || ""}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} style={{ marginTop: 0 }}>
              <Grid item md={3}>
                <Label className={classes.label}>Notes</Label>
              </Grid>

              <Grid item md={8}>
                <TextareaAutosize
                  className={classes.Textarea}
                  placeholder=""
                  value={this.state.notes || ""}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} style={{ marginTop: 0 }}>
              <Grid item md={3}>
                <Label className={classes.label} style={{ marginTop: "7px" }}>
                  History Notes
                </Label>
              </Grid>
              <Grid item md={8}>
                <TextareaAutosize
                  className={classes.Textarea1}
                  placeholder=""
                  value={this.state.history || ""}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} style={{ marginTop: 0 }}>
              <Grid item md={3}>
                <Label className={classes.label} style={{ marginTop: "7px" }}>
                  Examination Notes
                </Label>
              </Grid>
              <Grid item md={8}>
                <TextareaAutosize
                  className={classes.Textarea1}
                  placeholder=""
                  value={this.state.examination || ""}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} style={{ marginTop: 0 }}>
              <Grid item md={3}>
                <Label className={classes.label} style={{ marginTop: "-7px" }}>
                  Smoking History
                </Label>
              </Grid>
              <Grid item md={8}>
                <Button
                  className="button2"
                  style={{
                    backgroundColor: this.state.smoking
                      ? "lightgrey"
                      : "#03b3fb",
                  }}
                >
                  Yes
                </Button>
                <Button
                  className="button2"
                  style={{
                    backgroundColor: !this.state.smoking
                      ? "lightgrey"
                      : "#03b3fb",
                  }}
                >
                  No
                </Button>
              </Grid>
            </Grid>
          </Container>
        </form>
      </div>
    );
  }
}

NewConsultant.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles)(NewConsultant);
